/**
 * Enum for integration item types
 */
export enum IntegrationType {
    AZURE = 'azure',
    JIRA = 'jira',
    ASANA = 'asana',
    MONDAY = 'monday'
}

export enum ChildEntityType {
    TASK = "task",
    BUG = "bug",
    STORY = "story",
    EPIC = "epic",
    FEATURE = "feature",
    SUBTASK = "subtask",
    USER_STORY = "user story",
    AZURE_PROJECT = "azure_project",
    JIRA_PROJECT = "jira_project",
    ROADMAP_GROUP = "roadmap_group",
    ROADMAP = "roadmap",
    PROJECT = "project",
    FLOAT = "float",
    WORK_ITEM = "work item"
}

export const ChildEntityTypeConfig = {
    [ChildEntityType.TASK]: "Tasks",
    [ChildEntityType.BUG]: "Bugs",
    [ChildEntityType.STORY]: "Stories",
    [ChildEntityType.EPIC]: "Epics",
    [ChildEntityType.FEATURE]: "Features",
    [ChildEntityType.SUBTASK]: "Subtasks",
    [ChildEntityType.USER_STORY]: "User Stories",
    [ChildEntityType.PROJECT]: "Work Units",
    [ChildEntityType.FLOAT]: "Floats",
    [ChildEntityType.ROADMAP]: "Strategy Map",
    [ChildEntityType.ROADMAP_GROUP]: "Roadmap Groups",
    [ChildEntityType.AZURE_PROJECT]: "Azure Projects",
    [ChildEntityType.JIRA_PROJECT]: "Jira Projects",
    [ChildEntityType.WORK_ITEM]: "Work Items",
}

/**
 * Enum for integration item types
 */
export enum IntegrationItemType {
    TASK = 'task',
    BUG = 'bug',
    STORY = 'story',
    EPIC = 'epic',
    FEATURE = 'feature',
    SUBTASK = 'subtask',
    USER_STORY = 'user story',
    SPIKE = 'spike'
}

/**
 * Enum for integration status values
 */
export enum IntegrationStatus {
    RESOLVED = 'resolved',
    COMPLETED = 'completed',
    CLOSED = 'closed',
    REMOVED = 'removed',
    IN_PROGRESS = 'in progress',
    NEW = 'new',
    ACTIVE = 'active',
    DONE = 'done'
}

/**
 * Enum for dashboard status values
 */
export enum DashboardStatus {
    ON_TRACK = 'on_track',
    DELAYED = 'delayed',
    COMPLETED = 'completed',
    BLOCKED = 'blocked',
    UNASSIGNED = 'unassigned',
    CACHE_IN_PROGRESS = 'cache_in_progress',
    RUNNING = "running",
    CRITICAL = "delayed_critical",
    UNALLOCATED = "unallocated",
    WAITING = "waiting",
    NOT_STARTED = "not_started",
    AT_RISK = 'at_risk',
    CLOSED = 'closed',
}

/**
 * Object mapping integration types to their UI classes
 */
export const integrationTypeColors: Record<string, string> = {
    [IntegrationType.AZURE]: ' bg-blue-600 text-white ',
    [IntegrationType.JIRA]: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300',
    [IntegrationType.ASANA]: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300',
    [IntegrationType.MONDAY]: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300'
};

/**
 * Object mapping integration item types to their UI classes
 */
export const itemTypeColors: Record<string, string> = {
    [IntegrationItemType.TASK]: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
    [IntegrationItemType.BUG]: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
    [IntegrationItemType.STORY]: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-300',
    [IntegrationItemType.EPIC]: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
    [IntegrationItemType.SUBTASK]: 'bg-teal-100 text-teal-800 dark:bg-teal-900 dark:text-teal-300',
    [IntegrationItemType.FEATURE]: 'bg-gray-200 dark:bg-gray-700  text-gray-800 dark:text-white',
    [IntegrationItemType.USER_STORY]: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
    [IntegrationItemType.SPIKE]: 'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-300'
};

/**
 * Object mapping integration statuses to their UI classes
 */
export const progressStatusColors: Record<string, string> = {
    [IntegrationStatus.RESOLVED]: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
    [IntegrationStatus.COMPLETED]: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
    [IntegrationStatus.CLOSED]: 'bg-gray-200 text-gray-800 dark:bg-gray-600 dark:text-gray-300',
    [IntegrationStatus.REMOVED]: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
    [IntegrationStatus.IN_PROGRESS]: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
    [IntegrationStatus.NEW]: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
    [IntegrationStatus.ACTIVE]: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300',
    [IntegrationStatus.DONE]: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300'
};

/**
 * Object mapping dashboard statuses to their UI classes
 *
 */
// export const dashboardStatusColors: Record<string, string> = {
//     [DashboardStatus.ON_TRACK]: 'bg-green-500 text-white dark:bg-green-500',
//     [DashboardStatus.DELAYED]: 'bg-yellow-200 text-white dark:bg-yellow-200',
//     [DashboardStatus.COMPLETED]: 'bg-blue-200 text-white dark:bg-blue-200',
//     [DashboardStatus.BLOCKED]: 'bg-red-500 text-white dark:bg-red-500',
//     [DashboardStatus.UNASSIGNED]: 'bg-gray-500 text-white dark:bg-gray-600',
//     [DashboardStatus.CACHE_IN_PROGRESS]: 'bg-purple-500 text-white dark:bg-purple-600',
//     [DashboardStatus.UNALLOCATED]: 'bg-gray-400 text-white dark:bg-gray-400',
//     [DashboardStatus.RUNNING]: 'bg-yellow-400 text-white dark:bg-yellow-400',
//     [DashboardStatus.CRITICAL]: 'bg-red-500 text-white dark:bg-red-500',
//     [DashboardStatus.WAITING]: 'bg-pink-300 text-white dark:bg-pink-300',
//     [DashboardStatus.NOT_STARTED]: 'bg-green-200 text-white dark:bg-green-200'
// };
// export const dashboardStatusColors: Record<string, string> = {
//     [DashboardStatus.ON_TRACK]: 'bg-emerald-500 text-white',       // Green = Positive Progress
//     [DashboardStatus.DELAYED]: 'bg-amber-500 text-white',          // Amber = Warning/Delay
//     [DashboardStatus.COMPLETED]: 'bg-blue-500 text-white',         // Teal = Finished / Done
//     [DashboardStatus.BLOCKED]: 'bg-rose-600 text-white',           // Rose = Blocked/Error
//     [DashboardStatus.UNASSIGNED]: 'bg-slate-500 text-white',       // Slate = Neutral/Unassigned
//     [DashboardStatus.CACHE_IN_PROGRESS]: 'bg-purple-600 text-white',// Purple = System Process/Cache
//     [DashboardStatus.UNALLOCATED]: 'bg-zinc-400 text-white',       // Zinc = Unallocated Resource
//     [DashboardStatus.RUNNING]: 'bg-orange-500 text-white',         // Orange = Actively Running
//     [DashboardStatus.CRITICAL]: 'bg-[#fe4f4f] text-white',           // Red = Critical/Error
//     [DashboardStatus.WAITING]: 'bg-pink-400 text-white',           // Pink = Passive Waiting
//     [DashboardStatus.NOT_STARTED]: 'bg-lime-400 text-black',       // Lime = Fresh/Not Started
//     [DashboardStatus.CLOSED]: 'bg-gray-400 text-white',            // Gray = Closed
//     [DashboardStatus.AT_RISK]: 'bg-red-500 text-white'             // Red = At Risk
//   };
//   export const dashboardStatusHexColors: Record<string, string> = {
//     [DashboardStatus.ON_TRACK]: '#10b981',      // emerald-500
//     [DashboardStatus.DELAYED]: '#f59e42',       // amber-500
//     [DashboardStatus.COMPLETED]: '#3b82f6',     // blue-500
//     [DashboardStatus.BLOCKED]: '#be123c',       // rose-600
//     [DashboardStatus.UNASSIGNED]: '#64748b',    // slate-500
//     [DashboardStatus.CACHE_IN_PROGRESS]: '#7c3aed', // purple-600
//     [DashboardStatus.UNALLOCATED]: '#a1a1aa',   // zinc-400
//     [DashboardStatus.RUNNING]: '#f97316',       // orange-500
//     [DashboardStatus.CRITICAL]: '#fe4f4f',      // red-700
//     [DashboardStatus.WAITING]: '#ec4899',       // pink-400
//     [DashboardStatus.NOT_STARTED]: '#a3e635',   // lime-400
//     [DashboardStatus.CLOSED]: '#64748b',       // gray-400
//     [DashboardStatus.AT_RISK]: '#ef4444',       // red-500
// };

export const dashboardStatusColors: Record<string, string> = {
    [DashboardStatus.ON_TRACK]: 'bg-[#16a34a] text-white',      // forestGreen (success, positive)
    [DashboardStatus.DELAYED]: 'bg-[#f59e0b] text-white',       // amber (warning)
    [DashboardStatus.COMPLETED]: 'bg-[#0ea5e9] text-white',     // skyBlue (calm & done)
    [DashboardStatus.BLOCKED]: 'bg-[#991b1b] text-white',       // maroon (work stopped - blocker)
    [DashboardStatus.UNASSIGNED]: 'bg-[#6b7280] text-white',    // gray (inactive/neutral)
    [DashboardStatus.UNALLOCATED]: 'bg-[#ea580c] text-white',   // burnt orange (needs resources)
    [DashboardStatus.NOT_STARTED]: 'bg-[#8b5cf6] text-white',   // violet (pending / to-do)
    [DashboardStatus.CLOSED]: 'bg-[#64748b] text-white',        // slate (finalized)
    [DashboardStatus.AT_RISK]: 'bg-[#dc2626] text-white',       // red (critical)
};
export const dashboardStatusColorsHex: Record<string, string> = {
  [DashboardStatus.ON_TRACK]: "#16a34a",
  [DashboardStatus.DELAYED]: "#f59e0b",
  [DashboardStatus.COMPLETED]: "#0ea5e9",
  [DashboardStatus.BLOCKED]: "#991b1b",
  [DashboardStatus.UNASSIGNED]: "#6b7280",
  [DashboardStatus.UNALLOCATED]: "#ea580c",
  [DashboardStatus.NOT_STARTED]: "#8b5cf6",
  [DashboardStatus.CLOSED]: "#64748b",
  [DashboardStatus.AT_RISK]: "#dc2626",
};
export const dashboardStatusHexColors: Record<string, string> = {
    [DashboardStatus.ON_TRACK]: '#16a34a',      // forestGreen (success, positive)
    [DashboardStatus.DELAYED]: '#f59e0b',       // amber (warning)
    [DashboardStatus.COMPLETED]: '#0ea5e9',     // skyBlue (calm & done)
    [DashboardStatus.BLOCKED]: '#991b1b',       // maroon (work stopped - blocker)
    [DashboardStatus.UNASSIGNED]: '#6b7280',    // gray (inactive/neutral)
    [DashboardStatus.UNALLOCATED]: '#ea580c',   // burnt orange (needs resources)
    [DashboardStatus.NOT_STARTED]: '#8b5cf6',   // violet (pending / to-do)
    [DashboardStatus.CLOSED]: '#64748b',        // slate (finalized)
    [DashboardStatus.AT_RISK]: '#dc2626',       // red (critical)
};
/**
 * Get UI color class for integration source type
 */
export const getIntegrationTypeColor = (type: string): string => {
    return integrationTypeColors[type.toLowerCase()] || 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
};

/**
 * Get UI color class for integration item type
 */
export const getItemTypeColor = (type: string): string => {
    return itemTypeColors[type.toLowerCase()] || 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
};

/**
 * Get UI color class for integration status
 */
export const getProgressStatusColor = (status: string): string => {
    return progressStatusColors[status.toLowerCase()] || 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
};

/**
 * Get UI color class for dashboard status
 */
export const getDashboardStatusColor = (status: string): string => {
    if (status) {
        return dashboardStatusColors[status.toLowerCase()]
    }

    return 'bg-gray-400 text-white dark:bg-gray-600';
};
export const getDashboardStatusColorHex = (status: string): string => {
    if (status) {
        return dashboardStatusColorsHex[status.toLowerCase()]
    }

    return '#64748b';
};

/**
 * Get readable label for dashboard status
 */
export const getDashboardStatusLabel = (status: string): string => {
    if (!status) return "";

    switch (status.toLowerCase()) {
        case DashboardStatus.ON_TRACK:
            return 'On Track';
        case DashboardStatus.DELAYED:
            return 'Delayed';
        case DashboardStatus.COMPLETED:
            return 'Completed';
        case DashboardStatus.BLOCKED:
            return 'Blocked';
        case DashboardStatus.UNASSIGNED:
            return 'Unassigned';
        case DashboardStatus.CACHE_IN_PROGRESS:
            return 'In Progress';
        case DashboardStatus.UNALLOCATED:
            return 'Unallocated';
        case DashboardStatus.RUNNING:
            return 'Running';
        case DashboardStatus.CRITICAL:
            return 'Critical';
        case DashboardStatus.WAITING:
            return 'Waiting';
        case DashboardStatus.AT_RISK:
            return 'At Risk';
        case DashboardStatus.CLOSED:
            return 'Closed';
        case DashboardStatus.NOT_STARTED:
            return 'Not Started';
        default:
            return status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, ' ');
    }
};

/**
 * Get filter options for integration item types
 */
export const getItemTypeFilterOptions = () => {
    return [
        { value: '', label: 'All Types' },
        { value: IntegrationItemType.EPIC, label: 'Epic' },
        { value: IntegrationItemType.TASK, label: 'Task' },
        { value: IntegrationItemType.BUG, label: 'Bug' },
        { value: IntegrationItemType.STORY, label: 'Story' },
        { value: IntegrationItemType.SUBTASK, label: 'Subtask' },
        { value: IntegrationItemType.FEATURE, label: 'Feature' },
        { value: IntegrationItemType.USER_STORY, label: 'User Story' }
    ];
};

/**
 * Enum for task filter status values
 */
// export enum TaskFilterStatus {
//     COMPLETED = 'completed',
//     RUNNING = 'running',
//     DELAYED = 'delayed',
//     ON_TRACK = 'on_track',
//     CRITICAL = 'critical',
//     UNALLOCATED = 'unallocated',
//     WAITING = 'waiting',
//     NOT_STARTED = 'not_started'
// }



// export enum ProjectFilterStatus {
//     ON_TRACK = 'on_track',
//     COMPLETED = 'completed',
//     DELAYED = 'delayed',
//     UNALLOCATED = 'unallocated',
//     NOT_STARTED = 'not_started',
//     CLOSED = 'closed'
// }

/**
 * Get readable label for task filter status
 */
export const getTaskFilterStatusLabel = (status: string): string => {
    switch (status.toLowerCase()) {
        case DashboardStatus.COMPLETED:
            return 'Completed';
        case DashboardStatus.RUNNING:
            return 'Running';
        case DashboardStatus.DELAYED:
            return 'Delayed';
        case DashboardStatus.ON_TRACK:
            return 'On Track';
        case DashboardStatus.CRITICAL:
            return 'Critical';
        case DashboardStatus.UNALLOCATED:
            return 'Unallocated';
        case DashboardStatus.WAITING:
            return 'Waiting';
        default:
            return status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, ' ');
    }
};

/**
 * Get readable label for project filter status
 */
export const getProjectFilterStatusLabel = (status: string): string => {
    switch (status.toLowerCase()) {
        case DashboardStatus.ON_TRACK:
            return 'On Track';
        case DashboardStatus.COMPLETED:
            return 'Completed';
        case DashboardStatus.DELAYED:
            return 'Delayed';
        case DashboardStatus.UNALLOCATED:
            return 'Unallocated';
        default:
            return status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, ' ');
    }
};

/**
 * Get filter options for integration statuses
 */
export const getProgressFilterOptions = () => {
    return [
        { value: '', label: 'All Statuses' },
        { value: IntegrationStatus.RESOLVED, label: 'Resolved' },
        { value: IntegrationStatus.COMPLETED, label: 'Completed' },
        { value: IntegrationStatus.CLOSED, label: 'Closed' },
        { value: IntegrationStatus.REMOVED, label: 'Removed' },
        { value: IntegrationStatus.IN_PROGRESS, label: 'In Progress' },
        { value: IntegrationStatus.NEW, label: 'New' },
        { value: IntegrationStatus.ACTIVE, label: 'Active' },
        { value: IntegrationStatus.DONE, label: 'Done' }
    ];
};

/**
 * Get filter options for task statuses
 */
export const getTaskFilterOptions = () => {
    return [

        { value: '', label: 'All Statuses' },
        { value: DashboardStatus.ON_TRACK, label: 'On Track' },
        { value: DashboardStatus.DELAYED, label: 'Delayed' },
        { value: DashboardStatus.BLOCKED, label: 'Blocked' },
        { value: DashboardStatus.UNALLOCATED, label: 'Unallocated' },
        { value: DashboardStatus.COMPLETED, label: 'Completed' },
        { value: DashboardStatus.NOT_STARTED, label: 'Not Started' },
        { value: DashboardStatus.CLOSED, label: 'Closed' },
        // { value: DashboardStatus.CRITICAL, label: 'Critical' },
        // { value: DashboardStatus.WAITING, label: 'Waiting' }
    ];
};
export const getTaskStatsOptions = () => {
    return [
        { value: DashboardStatus.COMPLETED, label: 'Completed' },
        { value: DashboardStatus.DELAYED, label: 'Delayed' },
        { value: DashboardStatus.BLOCKED, label: 'Blocked' },
        { value: DashboardStatus.UNALLOCATED, label: 'Unallocated' },
        { value: DashboardStatus.NOT_STARTED, label: 'Not Started' },
    ];
};

/**
 * Get filter options for project statuses
 */
export const getProjectFilterOptions = () => {
    return [
        { value: '', label: 'All Statuses' },
        { value: DashboardStatus.ON_TRACK, label: 'On Track' },
        { value: DashboardStatus.DELAYED, label: 'Delayed' },
        { value: DashboardStatus.BLOCKED, label: 'Blocked' },
        { value: DashboardStatus.COMPLETED, label: 'Completed' },
        { value: DashboardStatus.UNALLOCATED, label: 'Unallocated' },
        { value: DashboardStatus.NOT_STARTED, label: 'Not Started' },
        { value: DashboardStatus.CLOSED, label: 'Closed' }
    ];
};
/**
 * Get filter options for epic statuses
 */
export const getProjectLevelFilterOptions = () => {
    return [
        { value: '', label: 'All Statuses' },
        { value: DashboardStatus.AT_RISK, label: 'At Risk' },
        { value: DashboardStatus.ON_TRACK, label: 'On Track' },
  
        { value: DashboardStatus.COMPLETED, label: 'Completed' },
        { value: DashboardStatus.NOT_STARTED, label: 'Not Started' },
        { value: DashboardStatus.CLOSED, label: 'Closed' }
    ];
};

export const getProjectStatsOptions = () => {
    return [
        { value: DashboardStatus.COMPLETED, label: 'Completed' },
        { value: DashboardStatus.DELAYED, label: 'Delayed' },
        { value: DashboardStatus.BLOCKED, label: 'Blocked' },
        { value: DashboardStatus.UNALLOCATED, label: 'Unallocated' },
        { value: DashboardStatus.NOT_STARTED, label: 'Not Started' },
    ];
};

export const getEpicFilterOptions = () => {
    return [
        { value: '', label: 'All Statuses' },
        { value: DashboardStatus.ON_TRACK, label: 'On Track' },
        { value: DashboardStatus.AT_RISK, label: 'At Risk' },
        { value: DashboardStatus.CLOSED, label: 'Closed' },
    ];
};

export const getSmapFilterOptions = () => {
    return [
        { value: '', label: 'All Statuses' },
        { value: DashboardStatus.AT_RISK, label: 'At Risk' },
        { value: DashboardStatus.ON_TRACK, label: 'On Track' },
        { value: DashboardStatus.COMPLETED, label: 'Completed' },
        { value: DashboardStatus.CLOSED, label: 'Closed' },
        { value: DashboardStatus.NOT_STARTED, label: 'Not Started' }
    ];
};
export const getStatusOptions = () => {
    return [
        { value: '', label: 'All Statuses' },
        { value: DashboardStatus.AT_RISK, label: 'At Risk' },
        { value: DashboardStatus.ON_TRACK, label: 'On Track' },
        { value: DashboardStatus.COMPLETED, label: 'Completed' },
        { value: DashboardStatus.CLOSED, label: 'Closed' },
        { value: DashboardStatus.NOT_STARTED, label: 'Not Started' }
    ];
};

export const getJiraEpicFilterOptions = () => {
    return [
        { value: '', label: 'All Statuses' },
    ];
}; 

export const stageBgColorMap: Record<string, string> = {
    idea: "bg-[#FDF6B2]",
    planning: "bg-[#EDEBFE]",
    executing: "bg-[#FDE8E8]",
    completed: "bg-[#DEF7EC]",
    archived: "bg-[#DEF7EC]",
    closed: "bg-[#64748b]"
};

export const stageTextColorMap: Record<string, string> = {
    idea: "text-[#723B13]",
    planning: "text-[#5521B5]",
    executing: "text-[#9B1C1C]",
    completed: "text-[#03543F]",
    archived: "text-[#03543F]",
    closed: "text-white"
};